export default "__VITE_ASSET__DfQiic3S__"